import stringUtils from '../utils/stringUtils';
import ListView from '../Common/Views/ListView';

import { Chip } from '@mui/material';

// Direction icons
import OutIcon from '@mui/icons-material/ArrowBack';
import InIcon from '@mui/icons-material/ArrowForward';

import PaymentStatusChip from './PaymentStatusChip';

const PaymentsList = ({
    filters = {},
    addButton = true,
    onSelect = null, // a function to override the table row click action (default is to navigate to details page)
    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
}) => {

    const displayDirection = (direction) => {
        if (direction === 'IN') {
            return <><InIcon fontSize="small" style={{ verticalAlign: 'middle', color: 'green' }} /> IN</>;
        }
        if (direction === 'OUT') {
            return <><OutIcon fontSize="small" style={{ verticalAlign: 'middle', color: 'red' }} /> OUT</>;
        }
        return 'N/A';
    }

    const displayMethod = (method) => {
        if (!method) return 'N/A';
        return method.charAt(0).toUpperCase() + method.slice(1).toLowerCase().replace('_', ' ');
    }

    // Columns configuration for rendering payments list
    const columnsConfig = {
        direction: {
            key: 'direction',
            label: 'Direction',
            render: row => displayDirection(row.direction)
        },
        amount: {
            key: 'amount',
            label: 'Amount',
            render: row => `${stringUtils.formatPriceWithCommas(row.amount)} ${row.currency}`
        },
        method: {
            key: 'method',
            label: 'Method',
            render: row => displayMethod(row.method)
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => <PaymentStatusChip status={row.status} />
        },
        createdAt: {
            key: 'createdAt',
            label: 'Created At',
            render: row => row.createdAt ? stringUtils.isoToLocalDateTime(row.createdAt) : 'N/A'
        },
        submittedAt: {
            key: 'submittedAt',
            label: 'Submitted At',
            render: row => row.submittedAt ? stringUtils.isoToLocalDateTime(row.submittedAt) : 'N/A'
        },
        dueAt: {
            key: 'dueAt',
            label: 'Due At',
            render: row => row.dueAt ? stringUtils.isoToLocalDateTime(row.dueAt) : 'N/A'
        },
        settledAt: {
            key: 'settledAt',
            label: 'Settled At',
            render: row => row.settledAt ? stringUtils.isoToLocalDateTime(row.settledAt) : 'N/A'
        },
    };

    return <ListView
        title="Payments"
        apiPath="/tenants/payments"
        filters={filters}
        addButton={false}
        // addButtonLabel="Record new payment"
        addPath="/payments/add"
        rowClickPath={(item) => `/payments/${item.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        // searchAttributes={[
        //     { name: "Name", value: "name" },
        //     { name: "Type", value: "type" },
        // ]}
        noResultsMessage="No payments found"
    />
};

export default PaymentsList;